// Neutral invalidation boundary: state services do not import the scene runtime.
// Model revisions retain their existing authority; these counters only cover
// context replacement and derived geometry that does not dirty the document.
let state = Object.freeze({ epoch: 0, geometryRevision: 0 });
const listeners = new Set();

function nextRevision(current) {
  return current >= Number.MAX_SAFE_INTEGER ? 1 : current + 1;
}

export function getRenderSceneInvalidationState() {
  return state;
}

export function invalidateRenderSceneContext(kind) {
  if (kind !== 'model' && kind !== 'project' && kind !== 'geometry') {
    throw new TypeError('Unknown render scene invalidation kind.');
  }
  if (kind === 'project') state = Object.freeze({ ...state, epoch: nextRevision(state.epoch) });
  if (kind === 'geometry') state = Object.freeze({ ...state, geometryRevision: nextRevision(state.geometryRevision) });
  const event = Object.freeze({ kind, ...state });
  for (const subscription of [...listeners]) {
    if (!listeners.has(subscription)) continue;
    try {
      const result = subscription.listener(event);
      if (result && typeof result.then === 'function') Promise.resolve(result).catch(() => undefined);
    } catch { /* One observer must not prevent model commits or other cleanup. */ }
  }
  return state;
}

export function subscribeRenderSceneInvalidation(listener) {
  if (typeof listener !== 'function') throw new TypeError('Scene invalidation listener must be a function.');
  const subscription = { listener };
  listeners.add(subscription);
  return () => { listeners.delete(subscription); };
}
